import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import Input from "../../../../../components/Common/Input/Input";
import Loader from "../../../../../components/Common/Loader/Loader";
import GroupArrowIcon from "../../../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcons/GroupArrowIcon";
import {
  setClassesOrSeriesAction,
  setDeleteManadatedClassAction,
} from "../../../../../store/actions/actionCreators/adminActionCreator/groupManagementActionCreator";
import {
  getSearchClassActionHandler,
  getSearchProgramsActionHandler,
  getUserGroupsManadatedShotclassesActionHandler,
} from "../../../../../store/actions/actionHandlers/adminActionHandler/groupManagementActionHandler";
import { groupManagement } from "../../../../../utils/mainTabs/admin/groupManagement/groupManagement";
import SearchSuggestionInput from "../SearchSuggestionInput/SearchSuggestionInput";
import ManageClasses from "./ManageClasses/ManageClasses";
import classes from "./ManageMandatoryLearnings.module.scss";
import ManageSeries from "./ManageSeries/ManageSeries";
import MandateNewClassOrSeries from "./MandateNewClassOrSeries/MandateNewClassOrSeries";
import { FormattedMessage, useIntl } from "react-intl";

export const frequncyNameConverter = (val) => {
  switch (parseInt(val)) {
    case 1:
      return "Monthly";
    case 2:
      return "Quarterly";
    case 3:
      return "Yearly";
    default:
      return;
  }
};

const ManageMandatoryLearnings = ({ params, tenantName }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageSize = 6;
  const methods = useForm({
    defaultValues: {
      classOrSeries: "Classes",
      repetitive: "Monthly",
    },
  });
  const { setValue, getValues } = methods;
  const arr = [
    { id: 1, val: "Classes" },
    { id: 2, val: intl.formatMessage({ id: "ANALYTICAL_REPORT_PROGRAM" }) },
  ];
  const repititiveValArr = [
    { id: 1, val: intl.formatMessage({ id: "FREQUENCY_MONTHLY_KEY" }) },
    { id: 2, val: intl.formatMessage({ id: "FREQUENCY_QUARTERLY_KEY" }) },
    { id: 3, val: intl.formatMessage({ id: "FREQUENCY_YEARLY_KEY" }) },
  ];
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { groupManagementReducer } = adminStateReducer;
  const { classOrSeriesData, deleteMandatedClassData } = groupManagementReducer;
  const [selectVal, setSelectVal] = useState("Classes");
  const [searchClassData, setSearchClassData] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [totalRows, settotalRows] = useState(0);
  const [classDetails, setClassDetails] = useState([]);
  const [classDetailsLoader, setClassDetailsLoader] = useState(false);
  const radioBtnVal = useMemo(() => ["One Time", "Repetitive"], []);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [selectedSearchData, setSelectedSearchData] = useState(null);
  const [mandateErrorMsg, setMandateErrorMsg] = useState("");
  const [searchLoader, setSearchLoader] = useState(false);

  const onDropdownOptionClick = (data) => {
    setValue("Search", data?.val);
    setSearchClassData([]);
    setSelectedSearchData(data);
    const isPresent = classOrSeriesData?.some((item) => {
      if (selectVal === "Classes") return data?.id === item?.ShotClass?.ID;
      else return data?.id === item?.Programs?.ID;
    });
    if (isPresent) {
      setMandateErrorMsg(
        `${selectVal === "Classes" ? "Class" : "Series"} is Already Mandated`
      );
    } else setMandateErrorMsg("");
  };

  const handleSearch = (e) => {
    const val = e?.target?.value?.trim();
    if (val !== "") {
      setSearchLoader(true);
      if (selectVal === "Classes")
        dispatch(
          getSearchClassActionHandler(val, "Published", "WithoutVTLT")
        ).then((response) => {
          if (response?.status === 200 && response?.data) {
            setSearchLoader(false);
            const updatedData = response?.data?.map((item) => {
              return { ...item, id: item?.ID, val: item?.Name };
            });
            setSearchClassData(updatedData);
          }
        });
      else
        dispatch(getSearchProgramsActionHandler(true, val, "Published")).then(
          (response) => {
            if (response?.status === 200 && response?.data) {
              setSearchLoader(false);
              let updatedData = [];
              response?.data?.forEach((item) => {
                if (item?.Programs) {
                  updatedData = [
                    ...updatedData,
                    {
                      ...item,
                      id: item?.Programs?.ID,
                      val: item?.Programs?.Name,
                    },
                  ];
                }
              });
              setSearchClassData(updatedData);
            }
          }
        );
    } else {
      setSearchClassData([]);
      setSelectedSearchData(null);
      setMandateErrorMsg("");
    }
  };

  const getUserGroupMandateShotClasses = useCallback(
    (type) => {
      setClassDetailsLoader(true);
      dispatch(
        getUserGroupsManadatedShotclassesActionHandler(
          type,
          pageNum,
          pageSize,
          params?.userGroupId
        )
      ).then((response) => {
        if (response?.status === 200 && response?.data) {
          settotalRows(response?.data?.TotalRows);
          setClassDetailsLoader(false);
          setClassDetails((prevState) => [
            ...prevState,
            ...response?.data?.Content,
          ]);
          dispatch(
            setClassesOrSeriesAction([
              ...classOrSeriesData,
              ...response?.data?.Content,
            ])
          );
        }
      });
    },
    [dispatch, pageNum, params]
  );

  const onSelectChange = (e) => {
    setSelectVal(e?.target?.value);
    setClassDetails([]);
    dispatch(setClassesOrSeriesAction([]));
    setPageNum(1);
    setHasMoreData(true);
    settotalRows(0);
    setValue("Search", "");
    setSearchClassData([]);
    setSelectedSearchData(null);
  };

  const fetchMoreData = () => {
    if (classDetails?.length >= totalRows) {
      setHasMoreData(false);
      return;
    }
    setPageNum((prevState) => prevState + 1);
  };

  useEffect(() => {
    const type = selectVal === "Classes" ? "ShotClass" : "Program";
    getUserGroupMandateShotClasses(type);
  }, [getUserGroupMandateShotClasses, selectVal]);

  useEffect(() => {
    if (classDetails?.length > 0) {
      classDetails?.forEach((data) => {
        const id =
          selectVal === "Classes" ? data?.ShotClass?.ID : data?.Programs?.ID;
        if (selectVal === "Classes" && data?.ShotClass?.IsRepetitive) {
          setValue(`priority${id}`, radioBtnVal?.[1]);
          setValue(
            `repetitive${id}`,
            data?.ShotClass?.Frequency
              ? data?.ShotClass?.FrequencyName
              : "Monthly"
          );
        } else if (selectVal === "Series" && data?.Programs?.IsRepetitive) {
          setValue(`priority${id}`, radioBtnVal?.[1]);
          setValue(
            `repetitive${id}`,
            data?.Programs?.Frequency
              ? data?.Programs?.FrequencyName
              : "Monthly"
          );
        } else setValue(`priority${id}`, radioBtnVal?.[0]);
      });
    }
  }, [classDetails, radioBtnVal, setValue, selectVal]);

  useEffect(() => {
    return () => {
      dispatch(setClassesOrSeriesAction([]));
    };
  }, [dispatch]);

  useEffect(() => {
    if (deleteMandatedClassData) {
      const type = selectVal === "Classes" ? "ShotClass" : "Program";
      getUserGroupMandateShotClasses(type);
      dispatch(setDeleteManadatedClassAction(null));
    }
  }, [
    deleteMandatedClassData,
    selectVal,
    getUserGroupMandateShotClasses,
    dispatch,
  ]);
  return (
    <div className={classes.manageMandatoryLearning}>
      <FormProvider {...methods}>
        <div className={classes.searchSuggestionInput}>
          <SearchSuggestionInput
            label={<FormattedMessage id="P_Search" />}
            placeholder={`Search ${
              selectVal === "Classes" ? "Class" : "Series"
            } to add`}
            name="Search"
            onChange={handleSearch}
            suggestionData={searchClassData}
            setValue={setValue}
            onDropdownOptionClick={onDropdownOptionClick}
          />
          {searchLoader && (
            <div className={classes.loader}>
              <Loader height="30%" width="30%" />
            </div>
          )}
        </div>
        {mandateErrorMsg && (
          <div className={classes.mandateErrorMsg}>{mandateErrorMsg}</div>
        )}
        {selectedSearchData && !mandateErrorMsg && (
          <MandateNewClassOrSeries
            selectedSearchData={selectedSearchData}
            setSelectedSearchData={setSelectedSearchData}
            getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
            selectVal={selectVal}
            radioBtnVal={radioBtnVal}
            repititiveValArr={repititiveValArr}
            setValue={setValue}
          />
        )}

        <div className={classes.heading}>
          <div className={classes.existingSeriesOrClass}>
            <GroupArrowIcon />
            <div className={classes.text}>
              {selectVal === "Classes" ? (
                <FormattedMessage id="USERGROUP_EXISTINGSHOTCLASS" />
              ) : (
                <FormattedMessage id="USERGROUP_EXISTINGPROGRAM" />
              )}
            </div>
          </div>
          <div className={classes.selectCourse}>
            <Input
              label={"Select Course Type :"}
              name="classOrSeries"
              fieldName="val"
              type="select"
              labelColor="light"
              width="18.8"
              height="2.9"
              valueArr={arr}
              onChange={onSelectChange}
            />
          </div>
        </div>
        {selectVal === "Classes" ? (
          <ManageClasses
            classDetails={classOrSeriesData}
            repititiveValArr={repititiveValArr}
            radioBtnVal={radioBtnVal}
            classDetailsLoader={classDetailsLoader}
            fetchMoreData={fetchMoreData}
            hasMoreData={hasMoreData}
            totalRows={totalRows}
            setValue={setValue}
            getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
            selectVal={selectVal}
            getValues={getValues}
          />
        ) : (
          <ManageSeries
            seriesDetails={classOrSeriesData}
            repititiveValArr={repititiveValArr}
            radioBtnVal={radioBtnVal}
            seriesDetailsLoader={classDetailsLoader}
            fetchMoreData={fetchMoreData}
            hasMoreData={hasMoreData}
            totalRows={totalRows}
            setValue={setValue}
            getUserGroupMandateShotClasses={getUserGroupMandateShotClasses}
            selectVal={selectVal}
            getValues={getValues}
          />
        )}
        <div
          className={classes.cancel}
          onClick={() => navigate(groupManagement.path(tenantName))}
        >
          <FormattedMessage id="CANCEL_TEXT" />
        </div>
      </FormProvider>
    </div>
  );
};

export default ManageMandatoryLearnings;
